import Vue from 'vue'

Vue.filter("toKiloLiter", function (value) {
  /*
    {{ nominal | toCurrency }}
  */
  if (typeof value !== "number" || value=="undefined"  || value=="NaN") {
      // return value;
  }
  
  var formatter = new Intl.NumberFormat('id-ID', {
      //style: 'currency',
      style: 'decimal',
      currency: 'IDR', //USD
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
  });
  //var ret= formatter.format(Math.floor(value/1000)).replace('$','').toString()
  //return ret+' KL'

  if (isNaN(value))
    return 0;

  let formattedNumber = formatter.format(Math.floor(value/1000));
  formattedNumber = formattedNumber.replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
  return formattedNumber + ' KL';
});

Vue.filter('toRupiah',function(value){
  if (typeof value !== "number" || value=="undefined"  || value=="NaN") {
      // return value;
  }
  var formatter = new Intl.NumberFormat('id-ID', {
      //style: 'currency',
      style: 'decimal',
      currency: 'IDR', //USD
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
  });

  //return formatter.format(value/1000).replace('$','Rp. ')+' K'
  if (isNaN(value))
    return 0;

  let formattedNumber = formatter.format(value/1000);
  formattedNumber = formattedNumber.replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
  return formattedNumber + ' K';

});

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('formatNum',function(value)
{
	if (typeof value !== "number" || value=="undefined"  || value=="NaN") {
		// return value;
	}
	var formatter = new Intl.NumberFormat('id-ID', {
		//style: 'currency',
    style: 'decimal',
		currency: 'IDR', //USD
		minimumFractionDigits: 0,
    maximumFractionDigits: 2
	});

	//return formatter.format(value).replace('$','')
  if (isNaN(value))
    return 0;

  let formattedNumber = formatter.format(value);
  formattedNumber = formattedNumber.replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
  return formattedNumber;
});




Vue.mixin({
	methods: {
		formatNum: (value)=> {
			if (typeof value !== "number" || value=="undefined"  || value=="NaN") {
				// return value;
			}
			var formatter = new Intl.NumberFormat('id-ID', {
        //en-ID
				//style: 'currency',
        style: 'decimal',
				currency: 'IDR', //USD
				minimumFractionDigits: 0,
        maximumFractionDigits: 2
			});

			//return formatter.format(value).replace('$','')

      if (isNaN(value))
        return 0;

      let formattedNumber = formatter.format(value);
      formattedNumber = formattedNumber.replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
      return formattedNumber;
		},
		
	}

});